
import api_list from "@/constant/apiUrl";
import app_config from "@/constant/config";
import { getUserDataRawLS } from "@/utility/helper/generalHandler";
import { startRequest } from "@/utility/helper/requestHelper";
import _ from "lodash";

export const getUpcomingEvents = async (params:any) => {
  const isUserLogin = !_.isEmpty(getUserDataRawLS());
  const apiData:any = {
    url: `${isUserLogin ? api_list.upcomingEvents : api_list.upcomingGuestEvents}`,
    method: "GET",
    params: {
      ...params
    }
  };
  if(isUserLogin) {
    apiData.headers = {
      token : getUserDataRawLS().token
    }
  }

  return startRequest(apiData, app_config.api_static);
};

export const getPastEvents = async (params:any) => {
  const isUserLogin = !_.isEmpty(getUserDataRawLS());
  const apiData:any = {
    url: `${isUserLogin ? api_list.pastEvents : api_list.pastGuestEvents}`,
    method: "GET",
    params: {
      ...params
    },
    headers: {
      ...params
    }
  };
  if(isUserLogin) {
    apiData.headers = {
      token : getUserDataRawLS().token
    }
  }

  return startRequest(apiData, app_config.api_static);
};


export const getDetailEvents = async (params:any) => {
  const isUserLogin = !_.isEmpty(params.hasCookie);
  const apiData:any = {
    url: `${isUserLogin ? api_list.eventsDetail : api_list.eventsDetailGuest}/${params.query.id}`, 
    method: "GET",
    params: {
      ...params.query,
    },
    headers: {
      ...params.query
    }
  };
  if(isUserLogin) {
    apiData.headers = {
      token: params.hasCookie.token,
    }
  }

  return startRequest(apiData, app_config.api_static);
};


export const registerEvent = async (postData:any) => {
  const isUserLogin = !_.isEmpty(getUserDataRawLS());
  const apiData:any = {
    url: api_list.agendaFormClient,
    method: "POST",
    data: postData
  };
  if(isUserLogin) {
    apiData.headers = {
      token : getUserDataRawLS().token
    }
  }

  return startRequest(apiData, app_config.api_static);
};